import reducers from "./globalSearchReducers";

export default reducers;
